module.exports = __webpack_public_path__ + "img/znyd.79a26ea3.png";